export default __webpack_public_path__ + "static/N0229-c0609cd4fdc8936b1a761838b8e4c91f.png";